/**
 * In-memory SMS draft store.
 *
 * Keeps the typed message and the selected from-number per conversation so a
 * user can navigate away and back without losing a draft. This is intentionally
 * NOT persisted to Firestore or localStorage — it lives only in module memory
 * for the current SPA session and is cleared on a full page reload.
 */

export interface SmsDraft {
  text?: string;
  fromNumber?: string;
}

const drafts = new Map<string, SmsDraft>();

export function getSmsDraft(key: string): SmsDraft | undefined {
  if (!key) return undefined;
  return drafts.get(key);
}

/** Persist (or clear) the draft body for a conversation. */
export function setSmsDraftText(key: string, text: string): void {
  if (!key) return;
  const existing = drafts.get(key) ?? {};
  if (text) {
    drafts.set(key, { ...existing, text });
  } else if (existing.fromNumber) {
    // Keep the chosen from-number even after the body is cleared.
    drafts.set(key, { fromNumber: existing.fromNumber });
  } else {
    drafts.delete(key);
  }
}

/** Persist the selected from-number for a conversation. */
export function setSmsDraftFrom(key: string, fromNumber: string): void {
  if (!key) return;
  const existing = drafts.get(key) ?? {};
  drafts.set(key, { ...existing, fromNumber });
}
